import { Box } from 'lucide-react';
import { useArSession } from './hooks/useArSession';
import type { ThreeCtx } from './hooks/useThreeScene';

// (#3) AR launch control.  Renders only when the device reports immersive-ar
// support, so desktop/unsupported browsers never see a dead button.
export function ArButton({ ctx }: { ctx: ThreeCtx | null }) {
  const ar = useArSession(ctx);
  if (!ar.supported) return null;
  return (
    <div className="ar-control" style={{ position: 'absolute', right: 12, bottom: 12, zIndex: 20 }}>
      <button
        type="button"
        onClick={() => (ar.active ? ar.stop() : ar.start())}
        title="Посмотреть в дополненной реальности (AR)"
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '8px 12px', borderRadius: 10, border: '1px solid var(--hz-border, #e6e1d8)',
          background: ar.active ? 'var(--hz-accent, #4ade80)' : 'var(--hz-surface, #fff)',
          color: ar.active ? '#fff' : 'var(--hz-text, #1c1a17)', cursor: 'pointer',
          fontSize: 13, fontWeight: 600,
        }}
      >
        <Box size={16} />
        {ar.active ? 'Выйти из AR' : 'Смотреть в AR'}
      </button>
      {ar.error ? (
        <div style={{ marginTop: 6, maxWidth: 220, fontSize: 11, color: 'var(--hz-danger, #dc2626)' }}>
          {ar.error}
        </div>
      ) : null}
    </div>
  );
}
